// extracted by mini-css-extract-plugin
export default {"main-container":"Main_main-container__5zdNs","main":"Main_main__MAvz7"};